import type { AllActionTypes } from '../constants';
import constants from '../constants';

export interface State {
  hoverId: string | null;
  activeId: string | null;
}

export type Actions = { type: AllActionTypes; payload: string };

const initialState: State = { hoverId: null, activeId: null };

const ui = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case constants.SET_HOVER_ID:
      return {
        ...state,
        hoverId: action.payload,
      };
    case constants.SET_ACTIVE_ID:
      return {
        ...state,
        activeId: action.payload,
      };
    default:
      return state;
  }
};

export default ui;
